import { useEffect } from "react";

export default function AdminSuper() {
  useEffect(() => {
    window.location.replace("/admin-super.html");
  }, []);
  return (
    <div className="flex min-h-screen items-center justify-center bg-maraca-navy text-white">
      <p className="font-display text-lg font-bold">Abrindo o painel do superadmin…</p>
    </div>
  );
}
